import { Link, useParams } from '@tanstack/react-router'
import { X } from 'lucide-react'

import { Button } from '@/components/button/button'

import { cn } from '@/lib/utils'

interface ApplicantCaseEoirDetailCloseProps {
  className?: string
}

export const ApplicantCaseEoirDetailClose: React.FC<ApplicantCaseEoirDetailCloseProps> = ({ className }) => {
  const { applicantId } = useParams({
    from: '/_app/applicants/$applicantId/cases-eoir/$caseNumber',
  })

  return (
    <Link className={cn(className)} to={`/applicants/$applicantId`} params={{ applicantId }}>
      <Button variant="ghost" size="icon">
        <X size={16} />
      </Button>
    </Link>
  )
}
